/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_FileInputs */

const en_wc_tut_ui_file = /** @type {(inputs: Wc_Tut_Ui_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File: new, open, save, export to PDF, document properties.`)
};

/**
* | output |
* | --- |
* | "File: new, open, save, export to PDF, document properties." |
*
* @param {Wc_Tut_Ui_FileInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_file = /** @type {((inputs?: Wc_Tut_Ui_FileInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_FileInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_file(inputs)
});
export { wc_tut_ui_file as "wc.tut.ui.file" }